import { render } from "./secondUpgradePage.vue?vue&type=template&id=f004a704&scoped=true"
import script from "./secondUpgradePage.vue?vue&type=script&lang=js"
export * from "./secondUpgradePage.vue?vue&type=script&lang=js"

import "./secondUpgradePage.vue?vue&type=style&index=0&id=f004a704&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_1b9778f7109bb3d60df46d4c8243c5fc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f004a704"]])

export default __exports__